module.exports = __webpack_public_path__ + "static/media/plus.4ad6cf20.svg";